// @flow
import React from 'react';

type Props = {
  onClose: () => {},
  onSubmit: () => {},
  onChange: () => {},
  value: string|number,
  UI: *,
};

class EditValueForm extends React.Component<Props> {

  render() {
    const {onClose, onSubmit, onChange, value, UI} = this.props;

    return (
      <form
        className="form-inline handle-counter-edit-form"
        onSubmit={onSubmit}
      >
        <input
          type="number"
          maxLength="10"
          className="form-control"
          value={value}
          onChange={onChange}
        />
        <button
          type="submit"
          disabled={UI.progress}
          className="btn btn-success btn-sm"
        >
          Save
        </button>
        <button
          type="button"
          disabled={UI.progress}
          onClick={onClose}
          className="btn btn-default btn-sm"
        >
          <i className="icon cancel-circled" />
        </button>
      </form>
    );
  }
}

export default EditValueForm;
